import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import { JsonObject } from "@Types/basic";
import classes from "./TermsOfUse.module.scss";

interface TermsOfUseProps {
  content?: JsonObject;
  termsTitle?: string;
}

export const TermsOfUse = ({ termsTitle, content }: TermsOfUseProps) => {
  return (
    <div className={`${classes["terms-of-use"]} ${classes["page--generic"]}`}>
      <h1>{termsTitle}</h1>
      <CmsTextEditorContent content={content} />
    </div>
  );
};
